import { Box, Fade, Slide, Stack, Zoom } from "@mui/material";
import { Answer, Question } from "../../../../domain/model/Question";
import { CustomTextView } from "../../../component/CustomTextView";
import { CustomImageView } from "../../../component/CustomImageView";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../../data/colors/Colors";
import {
  ArrowBackRounded,
  ArrowForwardRounded,
  AudioFileRounded,
} from "@mui/icons-material";
import {
  Attachment,
  AttachmentType,
} from "../../../../domain/model/Attachment";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import { useEffect, useState } from "react";

export function QuestionAnswerDetailsView({
  question,
  answer,
  showAnswer,
  showAttachment,
  isMobile,
}: {
  question: Question;
  answer: Answer;
  showAnswer: boolean;
  showAttachment: boolean;
  isMobile: boolean;
}) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(false);
    setTimeout(() => {
      setChecked(true);
    }, 100);
  }, [showAnswer]);
  return (
    <Zoom in={checked}>
      <Stack
        width={"100%"}
        height={"100%"}
        alignItems={"center"}
        justifyContent={
          showAnswer && !answer.attachment ? "center" : "space-between"
        }
        gap={2}
      >
        <Box />
        {checked && (
          <CustomTextView
            text={
              showAnswer
                ? `${answer.title}`
                : `${question.title?.replaceAll("؟", "").replaceAll("?", "")}؟`
            }
            fontWeight="bold"
            variant={isMobile ? "body1" : "h4"}
            textAlign="center"
            textColor={COLOR_WHITE}
            props={{ direction: "rtl" }}
          />
        )}
        {!showAnswer && checked && question.uncertainty && (
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <ArrowBackRounded
              sx={{ color: COLOR_WHITE }}
              fontSize={isMobile ? "small" : "medium"}
            />
            <Stack alignItems={"center"}>
              <CustomTextView
                text={question.uncertainty.title}
                variant={isMobile ? "caption" : "body1"}
                textAlign="center"
                textColor={COLOR_LIGHT_GRAY}
                props={{ direction: "rtl" }}
              />
              <CustomTextView
                text={question.uncertainty.value?.toString()}
                variant={isMobile ? "caption" : "h6"}
                textAlign="center"
                textColor={COLOR_WHITE}
                props={{ direction: "rtl" }}
              />
            </Stack>
            <ArrowForwardRounded
              sx={{ color: COLOR_WHITE }}
              fontSize={isMobile ? "small" : "medium"}
            />
          </Stack>
        )}

        {checked &&
          (showAnswer
            ? answer.attachment && (
                <AttachmentView
                  attachment={answer.attachment}
                  isMobile={isMobile}
                />
              )
            : showAttachment &&
              question.attachment && (
                <AttachmentView
                  attachment={question.attachment}
                  isMobile={isMobile}
                />
              ))}

        {!showAttachment && !showAnswer && <Box />}
      </Stack>
    </Zoom>
  );
}

export function AttachmentView({
  attachment,
  isMobile,
}: {
  attachment: Attachment;
  isMobile: boolean;
}) {
  const height = isMobile ? "35vh" : "32vh";

  switch (attachment.type) {
    case AttachmentType.IMAGE:
      return (
        <Stack width={"80%"}>
          <CustomImageView
            src={attachment.downloadUrl}
            width={"100%"}
            height={height}
            scale="contain"
            props={{
              borderRadius: 6,
              background: COLOR_WHITE,
            }}
          />
        </Stack>
      );

    case AttachmentType.VIDEO:
      return (
        <Stack height={height} width={"100%"}>
          <ReactPlayer
            width={"100%"}
            height={"100%"}
            style={{ background: COLOR_WHITE, borderRadius: 22 }}
            controls={true}
            stopOnUnmount
            url={attachment.downloadUrl}
          />
        </Stack>
      );
    case AttachmentType.AUDIO:
      return (
        <Stack height={height} width={"100%"}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <AudioFileRounded
              sx={{
                color: COLOR_WHITE,
                width: "8vw",
                height: "8vw",
              }}
            />
          </Box>
          <ReactAudioPlayer
            style={{ width: "100%", height: "20%" }}
            src={attachment.downloadUrl}
            controls
          />
        </Stack>
      );
  }
}
